import React, { type FC } from 'react';
import { Helmet } from 'react-helmet-async';

import { Content, SearchJob } from 'components';

export const JobSearchPage: FC = () => {
  return (
    <Content.$ dataTestId="job-search-page" hasContainer>
      <Helmet>
        <title>Job Search</title>
      </Helmet>
      <SearchJob.$ />
    </Content.$>
  );
};
